/**
 * useOddsComparison Hook (Web)
 * Thin wrapper around shared useOddsComparison
 */

import { API_BASE_URL } from '@config/api';
import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseOddsComparisonResult,
  useOddsComparison as useOddsComparisonShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';

// Re-export types and utilities for existing consumers
export type { UseOddsComparisonResult } from '@parlay-picker/shared/hooks';
export { buildComparisonKey } from '@parlay-picker/shared/hooks';

export function useOddsComparison(): UseOddsComparisonResult {
  const { authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useOddsComparisonShared({ httpClient });
}
